import { Link } from "react-router-dom";
import Coin from "../../../../Images/adhyayi_coin.png";
import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";
import { FaMedal, FaWpbeginner } from "react-icons/fa";
import { IoMedal } from "react-icons/io5";
import { MdSwipeDownAlt } from "react-icons/md";
import { Medal, MedalIcon } from "lucide-react";

const RechargeOfferCard = ({userData ,userAnalysis}) => {
  console.log("userAnalysis in RechargeOfferCard:", userAnalysis);
const contestTransaction =
  userAnalysis?.contest?.lastTransaction;

const isContestIncrease =
  contestTransaction?.isEarned || false;

const contestDifference =
  contestTransaction?.amount || 0;

 const joinedContests = userData?.joinedContests?.length || 0;

  return (
    <div className="w-full  bg-white rounded-3xl p-4 border border-purple-300 shadow-[0_12px_24px_rgba(0,0,0,0.12)]">

      {/* Top Row */}
      <div className="flex items-center justify-between ">
        
        {/* Left Icon */}
        <div className="w-10 h-10 rounded-2xl flex items-center  bg-purple-100 rounded-full justify-center">
          <Medal className="text-2xl text-bgBlue" />
        </div>

        
       {/* Right Test Count */}
         <p className="text-bgBlue bg-purple-100 p-2 rounded-[10px] text-sm font-medium">
          {joinedContests} Contests
        </p>
      </div>

      {/* Title */}
      <h2 className="text-lg font-bold text-black text-left">
        Contest
      </h2>
{/* Coins */}
<div className="flex items-center gap-2">
  <img
    src={Coin}
    alt="coin"
    className="w-12 h-12 object-contain"
  />

  <div className="flex items-center gap-1">
    <p className="text-md font-semibold text-[#5A5A5A] leading-none">
      {userData?.unifiedWallet?.contestBalance || 0}
    </p>

    <p className="text-sm text-gray-500 leading-none">
      Total Credits
    </p>
  </div>
</div>

      {/* Reward */}
<div
  className={`flex items-center justify-center w-36 gap-2 p-2 rounded-[10px] text-sm font-medium ${
    isContestIncrease
      ? "bg-green-100 text-green-600"
      : "bg-red-100 text-red-500"
  }`}
>
  {isContestIncrease ? (
    <FaArrowTrendUp />
  ) : (
    <FaArrowTrendDown />
  )}

  <span>
    {isContestIncrease ? "+" : "-"}
    {contestDifference} Credits
  </span>
</div>


    </div>
  );
};

export default RechargeOfferCard;